import { QuotationFile } from './quotationFile';
import { QuotationPart } from './quotationPart';
import { QuotationVehicle } from './quotationVehicle';

export interface Quotation {
    notes: string,
    parts: QuotationPart[],
    vehicle?: QuotationVehicle,
    pictures: QuotationFile[],
    quotationFile?: QuotationFile,
    isOrcamento: boolean,
}

export function quotationFactory(isOrcamento: boolean, notes: string, parts: QuotationPart[], pictures: QuotationFile[], quotationFile?: QuotationFile, vehicle?: QuotationVehicle) {
    return {
        isOrcamento: isOrcamento,
        notes: notes,
        parts: parts,
        vehicle: vehicle,
        pictures: pictures,
        quotationFile: quotationFile,
    } as Quotation;
}
